import moment from "moment";
import { getVidFleetEvent } from "Core/data/VideoEvents";
import { DEFAULTCOLOR, EVENTS_CODES } from "./constants";
import { v4 as uuidv4 } from 'uuid';

export const getRailEvents = (items = [], date, timeZone, totalSeconds = 300) => {
  const railColor = [];
  const eventsData = [];
  let color = DEFAULTCOLOR;
  const initialDate = moment.tz(date, timeZone).utc();
  if (items.length > 0) {
    items.forEach((item) => {
      const evDate = item.startTime != null
        ? moment(item.startTime).utc()
        : moment.tz(item.unitTime, timeZone).utc();
      const percentPerUnit = getPercentForGivenTime(initialDate, evDate, totalSeconds);
      color = EVENTS_CODES[item.eventName] || EVENTS_CODES[item.eventCode] || color;
      const searchEventData = getVidFleetEvent(item.eventCode);
      const eventsPositions = calculateTimelinePositions(item, date, color);
      railColor.push(eventsPositions);
      if (
        searchEventData.name !== "Default" &&
        searchEventData.name !== "AutoSnapshot"
      ) {
        eventsData.push({
          id: uuidv4(),
          dataEvent: searchEventData,
          position: percentPerUnit,
        });
      }
    });
  } 
  return { rail: railColor, eventData: eventsData };
};

const getPercentForGivenTime = (initialDate, date, totalSeconds = 300) => {
  const evSeconds = date.diff(initialDate, "seconds");
  if (evSeconds <= 0) return 0;
  if (evSeconds >= totalSeconds) return 100;
  return (evSeconds / totalSeconds) * 100;
};

export const getPairFromRange = (data = [], startD, timezoneUnit = "US/Eastern") => {
  const dates = [];
  //review
  const format = startD.subtract(1, "s").format("YYYY-MM-DD HH:mm:ss");
  let startRange = moment.tz(format, timezoneUnit).utc();
  let endRange = moment.tz(format, timezoneUnit).add(5, "minute").utc();
  startRange = startRange.valueOf();
  endRange = endRange.valueOf();
  data.forEach((item) => {
    const jsnParse = JSON.parse(item);
    //UTC method
    // const startClip = jsnParse[0];
    // const endClip = jsnParse[1];

    //timezone method
    let startClip = moment.tz(jsnParse[0], timezoneUnit).utc().valueOf();
    let endClip = moment.tz(jsnParse[1], timezoneUnit).utc().valueOf();

    if (startClip < startRange && endClip > startRange && endClip < endRange) {
      dates.push({ startClip: startRange, endClip });
    }

    // clip is larger than range
    if (startClip < startRange && endClip > endRange) {
      dates.push({ startClip: startRange, endClip: endRange });
    }

    // clip is inside of range
    if (startClip > startRange && startClip < endRange && endClip > endRange) {
      dates.push({ startClip, endClip: endRange });
    }

    // clip starts before range but finish between  range
    if (startClip > startRange && endClip < endRange) {
      dates.push({ startClip, endClip });
    }

  });
  return dates;
};

export const getTimeZoneUnit = (unitsList, deviceId) => {
  const gpsUnit = unitsList.find(item => item?.videoDevices?.find(device => device?.id == deviceId));

  if (!gpsUnit?.timeZone) {
    return {
      timeZone: {
        name: "US/Eastern"
      }
    };
  }

  return gpsUnit?.timeZone;
}

export const calculateTimelinePositions = (event, rangeStartDate, color, rangeMinutes = 5) => {
  const rangeStart = new Date(rangeStartDate).getTime();
  const rangeDuration = rangeMinutes * 60 * 1000;
  const rangeEnd = rangeStart + rangeDuration;

  const toMs = (value) =>
    typeof value === 'number' ? value : new Date(value).getTime();

    const eventStart = toMs(event.startTime);
    const eventEnd = toMs(event.endTime);

    // Opcional: clamp al rango
    const clampedStart = Math.max(eventStart, rangeStart);
    const clampedEnd = Math.min(eventEnd, rangeEnd);

    const left = ((clampedStart - rangeStart) / rangeDuration) * 100;
    const width = ((clampedEnd - clampedStart) / rangeDuration) * 100;

    return {
      left: `${Math.max(0, left)}%`,
      width: `${Math.max(0, width)}%`,
      color
    };
}


